var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-slider"},[_c('LightBox',{ref:"lightbox",attrs:{"media":_vm.images,"showLightBox":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }